import { memo } from 'react'

import type { AutoCompletePopoverProps } from './input.types'

import { styled } from '../core'
import { List } from '../list'
import { Popover } from '../popover'
import { cs } from '../utils'

const InputContainer = styled.divBox`
  width: 100%;
`

/** Wrapper for the autocomplete popover. */
export const AutoCompletePopover = ({
  autoCompleteOptions,
  autoCompleteMaxHeight,
  children,
  filterAutoCompleteOptions,
  onAutoCompleteSelect,
}: AutoCompletePopoverProps) => {
  if (autoCompleteOptions === undefined) return children

  return (
    <Popover placement="bottom-start" matchWidth>
      <Popover.Trigger as={InputContainer} className={cs('vui-input-popoverTrigger')}>
        {children}
      </Popover.Trigger>
      {!!autoCompleteOptions && (
        <Popover.Content>
          <List maxH={autoCompleteMaxHeight} w={'100%'} className={cs('vui-input-popoverList')}>
            {autoCompleteOptions?.filter?.(filterAutoCompleteOptions).map((i: string) => (
              <List.Item cursor="pointer" hoverBg="skyBlue.hover" key={i} onClick={() => onAutoCompleteSelect(i)}>
                {i}
              </List.Item>
            ))}
          </List>
        </Popover.Content>
      )}
    </Popover>
  )
}

export default memo(AutoCompletePopover)
